import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'arbeitsmittel',
  title: 'Arbeitsmittel',
  description:
    'Arbeitsmittel erfassen, verwalten und deren aktuellen Status dokumentieren.',
  icon: 'Wrench',
  order: 80,
  apiBasePath: '/api/arbeitsmittel',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  roles: ['arbeitsmittel.nutzer', 'arbeitsmittel.admin'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
